import React from 'react';
import './BlogList.css';


const BlogList = ({ blogs, title }) => {
  return (
    <div className="blog-list">
      <h2 class="s-title">{ title }</h2>
      {blogs.map(blog => (
        <div  key={blog.id} >
          <h2 class='sub-title'>{ blog.title }</h2>
          <p class="tech-text">{ blog.body }</p>
          <p className="blog-preview" >Category as { blog.author }</p>
        </div>
      ))}
    </div>
  );
}
 
export default BlogList;